module.exports = __webpack_public_path__ + "img/qxc_icon.80133eb9.png";